import PropTypes from "prop-types";
import { Fragment, Children, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ContentModulesContainer from "components/source/shared/content-modules-container";
import { fetchCmsMidGrid } from "../../../slices/midGrid-slice";
import { getRentalIntent } from "helpers/rental-intent-helper";

function MidGridRender({ children }) {
  const dispatch = useDispatch();
  const currentIntent = useSelector(state => getRentalIntent(state?.userData));
  const isMobileViewport = useSelector(state => state?.browser?.isMobileViewport);
  const midGridContent = useSelector(state => state?.midGridContent);
  const childrenAsArray = Children.toArray(children);

  const imageLazyLoadIndex = 0; // porting this value from old code, this lazy loads all images

  useEffect(() => {
    dispatch(fetchCmsMidGrid(window.location?.pathname));
  }, []);

  const canRenderMidGrid = index => {
    return contentBlockFinder(midGridContent || [], index, currentIntent, isMobileViewport)?.length > 0;
  };

  return (
    <Fragment>
      {Array.isArray(childrenAsArray) &&
        childrenAsArray.length > 0 &&
        childrenAsArray.map((child, index) => (
          <>
            <>
              {canRenderMidGrid(index) && (
                <span className="mid-grid-messaging">
                  <ContentModulesContainer
                    contentModules={contentBlockFinder(midGridContent || [], index, currentIntent, isMobileViewport)}
                    imageLazyLoadIndex={imageLazyLoadIndex}
                  />
                </span>
              )}
            </>
            {child}
          </>
        ))}
    </Fragment>
  );
}

MidGridRender.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default MidGridRender;

// ported from old code from old grid.jsx
// Finds the relevant content blocks for CMS to render
// felt its safer to follow the same pattern
function contentBlockFinder(cmsContent, index, currentIntent, isMobileViewport) {
  return cmsContent
    ?.filter(c => {
      const matchingIndex = isMobileViewport ? c.mobileIndex : c.index;
      return index === matchingIndex;
    })
    .filter(c => {
      return c.intent ? c.intent === currentIntent : true;
    });
}
